import { PageNav, NavTab } from "@ugg/shared/components/common/PageNav";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { useActiveSpecialModes, SPECIAL_GAME_MODES } from "@ugg/shared/utils/special-game-modes";
import { tierListPageUrls } from "@ugg/shared/pages/tier-list-pages";
import { QueueTypeS } from "@ugg/shared/utils/queue-type-helpers";

export function TierListPageNav({ className }: { className?: string }) {
  const activeModes = useActiveSpecialModes({ ssr: true });

  const isAramMayehmActive = activeModes.findIndex((mode) => mode === QueueTypeS.ARAM_MAYHEM) !== -1;

  const specialModeTabs: NavTab[] = activeModes.map((mode) => {
    const { tierListPageName, tierListSettings, newTag } = SPECIAL_GAME_MODES[mode];
    return {
      to: tierListPageUrls[tierListPageName],
      // Nav shows a shorter label for ARAM Mayhem than the page title
      // ("ARAM Mayhem Tier List"); the page itself keeps the full title.
      label: mode === QueueTypeS.ARAM_MAYHEM ? "ARAM Mayhem" : tierListSettings.title.main,
      reset: true,
      new: newTag,
    };
  });

  const tabs: NavTab[] = [
    {
      to: AppRoutes.DEFAULT_TIER_LIST,
      label: "Tier List",
      activePaths: [
        AppRoutes.TOP_TIER_LIST,
        AppRoutes.JUNGLE_TIER_LIST,
        AppRoutes.MID_TIER_LIST,
        AppRoutes.ADC_TIER_LIST,
        AppRoutes.SUPPORT_TIER_LIST,
      ],
    },

    // Drew: Classic Tier List sits at the front of the special game modes
    // and is ALWAYS shown on the site — unlike the modes below it isn't
    // gated on a patch's tier-list data being live (its data is shipped
    // for launch), so it's a static tab rather than coming through
    // useActiveSpecialModes. Shown in both shells — the shared
    // TierListRoutes table routes it on web and in the desktop app.
    { to: AppRoutes.CLASSIC_TIER_LIST, label: "Classic Tier List", reset: true, new: true },

    ...specialModeTabs,

    ...(isAramMayehmActive ? [{ to: AppRoutes.ARAM_MAYHEM_AUGMENT_TIER_LIST, label: "Mayhem Augments", new: true }] : []),

    // Last tab in both shells. Combat and Objectives used to follow this on the
    // desktop app only, but with Classic and the two Mayhem tabs added the row
    // no longer fits the app's content column — they overflowed into the
    // horizontal scroll area and were effectively invisible. Both shells now
    // reach them from the side nav's Tier List dropdown instead, which is the
    // same call the website already made.
    { to: AppRoutes.DUO_TIER_LIST, label: "Duo Tier List" },
  ];

  return <PageNav className={className} tabs={tabs} />;
}
